
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import ScriptExecutionService from '../../services/script-execution.service';
import { useQuery } from 'react-query';
import { WDAC_SCRIPT_EXECUTION_DETAILS_QUERY_KEY } from '../../constants/query';

const useGetScriptExecutionDetails = ({ scriptExecutionId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

   return useQuery(
    [WDAC_SCRIPT_EXECUTION_DETAILS_QUERY_KEY, scriptExecutionId],
    () =>
      ScriptExecutionService.getScriptExecutionDetails({
        scriptExecutionId,
        customerEnvId,
      })
  );
};

export default useGetScriptExecutionDetails;
